import { richTextToPlainText } from '../../../../utils/richTextToPlainText';

interface IBeneficiosMiPymesAccordionProps {
    id?: string;
    title: string;
    subtitle: string;
    items: {
        id: string;
        title: string;
        description: string;
    }[];
    imageSrc: string;
    ctaLabel: string;
    ctaAction: string;
    className?: string;
}

function beneficiosMiPymesAccordionAdapter(
    data: any,
): IBeneficiosMiPymesAccordionProps {
    return {
        id: data.autoresArticulo?.[0] ?? '',
        title: data.tituloGeneral ?? '',
        subtitle: data.etiquetasArticulo?.[0] ?? '',
        imageSrc: data.imagenPrincipal?.file?.url ?? '',
        ctaLabel: data.tituloBoton ?? '',
        ctaAction: data.redireccionBoton ?? '',
        items: data.referenciaPlantillaContenido?.map(
            (item: any, idx: number) => ({
                id: item.tituloBanner.replace(' ', '-').toLowerCase() + idx,
                title: item.tituloBanner ?? '',
                description: richTextToPlainText(JSON.parse(item.descripcion.raw) ?? ''),
            }),
        ),
    };
}
export default beneficiosMiPymesAccordionAdapter;
